<script setup>
const props = defineProps({
  filters: {
    type: Array,
    required: true,
  },
  maxFilterControls: {
    type: Number,
    default: 3,
  },
})

const singleFilters = computed(() => {
  return props.filters.length > props.maxFilterControls ? props.filters.slice(0, props.maxFilterControls - 1) : props.filters
})
const moreFilters = computed(() => {
  return props.filters.length > props.maxFilterControls ? props.filters.slice(props.maxFilterControls - 1) : undefined
})
</script>

<template>
  <div class="flex flex-row flex-wrap items-end flex-gap-4">
    <slot name="customFilter" />
    <DataFilterSingle
      v-for="(filter, index) in singleFilters"
      :key="`filter_${index}`"
      :filter="filter"
    />
    <DataFilterGroupDesktopDropdown
      v-if="moreFilters"
      :filters="moreFilters"
    />
  </div>
</template>
